import { TPpdApp } from "../../../App/PpdApp";
import { SpoBaseTask } from "../SpoBase/SpoBaseTask";
import { PpdStoredValues } from "../../../App/PpdStoredValues";

/**
 * Třída reprezentující úlohu pro hranice v rámci PopisSite.
 * Dědí ze základní třídy SpoBaseTask a rozšiřuje ji o specifické chování pro hranice.
 */
export class THraniceTask extends SpoBaseTask {
    /**
     * Kolekce uživatelských výběrů filtru v ribbonu.
     * Ukládá a obnovuje hodnoty filtru pro hranice.
     */
    public override userStoredRibbonFilterValues: PpdStoredValues = new PpdStoredValues("Hranice_filter", "1", this.repairStoredRibbonFilterValues, this);

    /**
     * Zjišťuje dostupnost XML pro celou síť.
     * V této implementaci není XML dostupné, metoda pouze vrací void.
     * @returns {Promise<void>} Vrací prázdný Promise.
     */
    public override async IsWholeNetXmlAvailable(): Promise<void> {
        return;
    }
}

/**
 * Inicializace skriptu pro úlohu hranic.
 * Vytváří instanci aplikace a úlohy, upravuje ribbon a načítá pohled dle filtru.
 */
ScriptInit(new TPpdApp(), new THraniceTask());

$(async function () {    
    // Načtení při inicializaci
    (CurrentTask as THraniceTask).changeViewByRibbonFilter();
});